// extracted by mini-css-extract-plugin
export var page = "pagePublish-module--page--5bDWg";
export var face = "pagePublish-module--face--d52Ha";
export var star = "pagePublish-module--star--aJElx";
export var paper = "pagePublish-module--paper--Wqcjl";
export var pen = "pagePublish-module--pen--p+wC9";